<template>
  <div>
    <template v-if="!loggedIn">
      <h1>Please log in first</h1>
    </template>

    <template v-if="loggedIn && !Management">
      <h1>Loading management API</h1>
    </template>

    <template v-if="loggedIn && Management">
      <h1>Accounts explorer</h1>

      <div v-if="accounts" id="accounts">
        <v-text-field v-model="search" append-icon="search" placeholder="Filter results"></v-text-field>
        <v-data-table
          :rows-per-page-items="rowsPerPage"
          :headers="headers.accounts"
          :items="accounts"
          :search="search"
        >
          <template slot="items" slot-scope="props">
            <router-link :to="`/accounts/${props.item.id}`" tag="tr">
              <td>{{ props.item.name }}</td>
              <td class="text-xs-left">{{ props.item.id }}</td>
              <td class="text-xs-left">{{ props.item.kind }}</td>
              <td class="text-xs-left">{{ props.item.selfLink }}</td>
            </router-link>
            <tr to="/test"></tr>
          </template>
        </v-data-table>

        <v-btn id="fetchAccounts" v-if="!accounts.length" @click="fetchAccounts">Load accounts</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import store from "@/store.js";

export default {
  name: "Accounts-overview",
  data() {
    return {
      accounts: [],
      search: "",
      rowsPerPage: [
        15,
        25,
        50,
        { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
      ],
      headers: {
        accounts: [
          {
            text: "Account Name",
            align: "left",
            value: "name"
          },
          { text: "Account ID", value: "id" },
          { text: "Kind", value: "kind" },
          { text: "Link", value: "link" }
        ]
      }
    };
  },
  computed: {
    Management() {
      return this.$store.state.google.management;
    },
    loggedIn() {
      return this.$store.state.auth.signedIn;
    }
  },
  methods: {
    fetchAccounts() {
      this.Management.accounts
        .list()
        .then(res => {
          if (res.status === 200) {
            this.accounts = res.result.items;
          }
        })
        .catch(err => console.error(err));
    }
  },
  mounted() {
    this.$store.dispatch("setNavigation", {});
    if (this.Management && !this.accounts.length && this.loggedIn) {
      this.fetchAccounts();
    }
  },
  watch: {
    Management(newV, oldV) {
      if (!oldV && newV && this.accounts.length == 0) {
        this.fetchAccounts();
      }
    }
  }
};
</script>




<style scoped>
tr,
td {
  cursor: pointer;
}
</style>

